import React from 'react';
import { useParams } from 'react-router-dom';
import OrgsTab from 'src/features/projects/OrgsTab';

export default function ProjectOrgsPage() {
    const { projectId } = useParams();
    if (!projectId) return null;
    return <OrgsTab projectId={projectId} />;
}
